/****************************************************
 * Module Name:  addBusinesstypeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import BusinesstypeProxy from "../../utility/proxy/manager/businesstypeProxy";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import Constants from "../../utility/constants";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddBusinesstypeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newbusinesstype: this.props.editOperation
        ? this.props.sourceData.name
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateBusinesstypePresentSpinner: false,
      showValidationMessage: false,
      businesstypeAvailable: true,

      businesstypeValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newbusinesstype,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateBusinesstypePresent = (businesstypeEntered) => {
    if (!businesstypeEntered || businesstypeEntered.trim() === "") return;

    this.setState({
      validateBusinesstypePresentSpinner: true,
    });

    BusinesstypeProxy.CheckBusinesstypeAvailable(
      businesstypeEntered,
      (response) => {
        //if we got response that means businesstype is present at backend
        if (response) {
          //BusinesstypeName already present
          this.setState({
            validateBusinesstypePresentSpinner: false,
            showValidationMessage: true,
            businesstypeAvailable: false,
          });
        } else {
          //BusinesstypeName not available, so can be used
          this.setState({
            validateBusinesstypePresentSpinner: false,
            showValidationMessage: true,
            businesstypeAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage || !this.state.businesstypeAvailable
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add businesstype validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Business type"
                : "Add New Business type"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Business type Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Business type <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newbusinesstype}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Business type (required)"
                          placeholder="Enter Business type"
                          value={this.state.newbusinesstype}
                          autoFocus
                          onBlur={(e) =>
                            this.validateBusinesstypePresent(
                              this.state.newbusinesstype
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newbusinesstype: e.target.value,
                              showValidationMessage: false,
                              businesstypeValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Business type Cannot be Empty",
                            })
                          }
                          helperText={this.state.businesstypeValidationError}
                          error={
                            this.state.businesstypeValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateBusinesstypePresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.businesstypeAvailable ? (
                        <font color="green">Business type available</font>
                      ) : (
                        <font color="red">Business type not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
